//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { request } from '@/tools/index.js'
import { jssdk, isIphonex } from '@runwork/runwork-help'
import surveyList from './components/QuestionnaireList.vue'
import BottomNavigation from '@/components/navigation/Index.vue'
import { dataList, listNum } from '@/mock/timu.js'
export default {
  name: 'index-page',
  data() {
    return {
      currentIndex: 0,
      dataList: [],
      listNum: [],
      isRW3: undefined, // 平台标志 3.0 true
      currentPage: 1,
      totalPage: 1,
      pullUpLoad: {
        threshold: 0,
        txt: {
          more: ' ',
          noMore: '没有更多数据',
        },
      },
      pullDownRefresh: {
        threshold: 80,
        stop: 40,
        stopTime: 200,
        txt: '更新完成',
      },
    }
  },
  components: {
    surveyList,
    BottomNavigation,
  },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
    status() {
      switch (this.currentIndex) {
        case 0:
          return 10
        case 1:
          return 20
        case 2:
          return 30
        default:
          return 10
      }
    },
  },
  watch: {
    currentIndex() {
      const loading = new this.$Loading()
      this.init()
        .then(() => {
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
  },
  async created() {
    const loading = new this.$Loading()
    try {
      await this.$nativeBridgeReady()
      await this.init()
      console.log('平台：', window.h5sdk ? 3.0 : 2.0)
      this.isRW3 = window.h5sdk ? true : false
      loading.close()
    } catch (err) {
      console.log(err)
      loading.close()
    }
  },
  methods: {
    init() {
      let promiseArr = [this.getListData()]
      return Promise.all(promiseArr)
    },
    getListData(isAppend) {
      const userCode = this.user.ldap
      const params = {
        userCode,
        commonPageDTO: {
          currentPage: this.currentPage,
          pageSize: 10,
        },
        sortDTO: {},
      }
      return request('getQuestionnaireList', params).then((res) => {
        this.currentPage = res.currentPage
        this.totalPage = res.pageCount
        let list = res.recordList || []
        if (isAppend) {
          this.dataList = this.dataList.concat(list)
        } else {
          this.dataList = list
        }
      })
    },
    async onPullingDown(done) {
      this.currentPage = 1
      //模拟请求更新数据
      await this.getListData()
      this.$refs['scroll'].forceUpdate()
    },
    onPullingUp(done) {
      //如果是最后一页
      if (this.currentPage === this.totalPage) {
        console.log(this.currentPage)
        this.$refs['scroll'].forceUpdate()
        return
      }
      this.currentPage = this.currentPage + 1
      this.getListData(true)
    },
    scrollTo(mark) {
      const scrollDom = document.querySelector('.scroll-y')
      scrollDom.scrollTop =
        document.getElementById(`nav-${mark}`).offsetTop - scrollDom.offsetTop
    },
    closeWebApp() {
      this.$router.push('/home')
    },
    getTips() {
      console.log('获取提示...')
      let uat = 'https://uat.rwork.crc.com.cn/docs/dock9BSwPFosbD5j7navMrJJFlb'
      let prd = 'https://app.rwork.crc.com.cn/docs/dock9YvmLiHRmBlcdpPuYaSDzrc'
      window.location.href =
        process.env.VUE_APP_H5_ENV !== 'production' ? uat : prd
    },
    submitFun(funName, emitObj) {
      const loading = new this.$Loading()
      try {
        const userCode = this.user.ldap
        const { callback, submitObj } = emitObj
        const params = {
          userCode,
          ...submitObj,
        }
        return request(funName, params).then((res) => {
          typeof callback == 'function' ? callback() : ''
          this.currentPage = 1
          this.getListData()
          loading.close()
        })
      } catch (err) {
        console.log(err)
        loading.close()
      }
    },
    refresh() {
      this.currentPage = 1
      this.getListData()
    },
    // 删除
    deleteItem(emitObj) {
      this.submitFun('deleteQuestion', emitObj)
    },
    //复制
    copy(emitObj) {
      this.submitFun('copyTeamplate', emitObj)
    },
  },
}
